module.exports = __webpack_public_path__ + "img/appstore_ca-ES.6aa54104.svg";